import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import CustomerHelper from '@/helpers/customerHelper';
import { STORAGE_KEYS } from '@/constants/storageKeys';

export interface User {
  id?: number | string;
  name?: string;
  surname?: string;
  email?: string;
  phone?: string;
  avatarUrl?: string;
  [key: string]: unknown;
}

export const useAuthStore = defineStore('auth', () => {
  // State
  const user = ref<User | null>(null);
  const isAuthenticated = computed(() => user.value !== null);

  // Actions
  const loadUserFromStorage = () => {
    const storedUser = localStorage.getItem(STORAGE_KEYS.USER);
    if (storedUser) {
      try {
        user.value = JSON.parse(storedUser);
      } catch {
        user.value = null;
      }
    }
  };

  const setUser = (userData: User | null) => {
    user.value = userData;
    if (userData) {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(userData));
    } else {
      localStorage.removeItem(STORAGE_KEYS.USER);
    }
  };

  const logout = (options?: { redirect?: boolean }) => {
    user.value = null;
    localStorage.removeItem(STORAGE_KEYS.USER);
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.TENANT);
    localStorage.removeItem(STORAGE_KEYS.USER_DATA);
    
    if (options?.redirect !== false && typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  };

  const getCustomerId = (): number | string | null => {
    return CustomerHelper.resolveCustomerId() ?? null;
  };

  const ensureValidSession = () => {
    CustomerHelper.ensureValidSession();
    loadUserFromStorage();
  };

  return {
    // State
    user,
    isAuthenticated,
    
    // Actions
    loadUserFromStorage,
    setUser,
    logout,
    getCustomerId,
    ensureValidSession,
  };
});
